import { render, staticRenderFns } from "./DRPTransaction.vue?vue&type=template&id=a10cc9c4&scoped=true"
import script from "./DRPTransaction.vue?vue&type=script&lang=js"
export * from "./DRPTransaction.vue?vue&type=script&lang=js"
import style0 from "./DRPTransaction.vue?vue&type=style&index=0&id=a10cc9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10cc9c4",
  null
  
)

export default component.exports